import { useOfflineRichContentMediaUrls } from '@/hooks/useOfflineRichContentMediaUrls'

export function TourStepBody({ body }: { body: string }) {
  const html = useOfflineRichContentMediaUrls(body)
  return <p dangerouslySetInnerHTML={{ __html: html }} />
}
